var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.166 28a1.094 1.094 0 01-.994-.575 1.048 1.048 0 010-1.151L15.006.574a1.146 1.146 0 011.988 0l14.831 25.7a1.048 1.048 0 010 1.151 1.094 1.094 0 01-.994.575zm14.987-17.337a1.113 1.113 0 00-1.147 1.151V18.1a1.147 1.147 0 102.294 0v-6.29a1.113 1.113 0 00-1.147-1.151zm0 12.849a1.113 1.113 0 10-.822-.326 1.112 1.112 0 00.822.326z",
    fill: "#ff9700"
  })));
}
export default SvgWarningWeb;